import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Room} from "../_models/room";
import {apiUrl} from "../../environments/environment";
import {PhaseGroup} from "../_models/phase";

@Injectable({
  providedIn: 'root'
})
export class PhaseGroupService {

  constructor(private http: HttpClient) { }

  getAllPhaseGroupByProject(projectId: number) {
    return this.http.get<PhaseGroup[]>(`${apiUrl}/project/${projectId}/phase-group/list`, {withCredentials: true})
  }
}
